import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import DA from '../store/ReduxAccess';

import facePageStyles from '../assets/jss/crm/views/facePageStyles';

import KSelect from './KSelect';
import CrmRadio from './CrmRadio';

const businessTypeWidgetStyles = (theme) => ({
  ...facePageStyles(theme),
  radioDiv: {
    transform: 'scale(0.9)',
    height: '32px',
  },
});

/*
Call with
  <BusinessTypeWidget
    visibleFirmId={<visibleFirmId>}
    filterOutPrivatePractitioners={true or omit this}
    firmType="<firmType>" //optional
    fixedType="<firmType>" //optional
    onChange={<someFunction(newFirmType)>}
  />
*/

class BusinessTypeWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // firmType: props.firmType || 'Treatment Center',
      firmType: props.firmType,
    };
  }

  componentDidMount() {
    const { visibleFirmId, fixedType, firmType } = this.props;
    if (visibleFirmId) {
      const firm = DA.getFirmById(visibleFirmId);
      this.setState({ firmType: firm.firmType });
    } else if (fixedType) {
      this.setState({ firmType: fixedType });
    } else {
      // this.setState({ firmType: firmType || 'Treatment Center' });
      this.setState({ firmType: firmType });
    }
  }

  handleBusinessTypeChange(newType) {
    this.setState({ firmType: newType });
    this.props.onChange(newType);
  }

  renderAsRadioButtons(possibleVisibleFirmTypes) {
    const { classes, fixedType } = this.props;
    if (!possibleVisibleFirmTypes || possibleVisibleFirmTypes.length === 0) {
      possibleVisibleFirmTypes = ['Hospital', 'Treatment Center', 'Private Practitioner'];
    }

    return (
      <div>
        <div className={cx(classes.formFramework_label, classes.businessTypeLabel)}>Business Type</div>
        <div className={classes.formFramework_content}>
          <div className={cx(classes.formFramework_item, classes.formFramework_businessTypeItem)}>
            {possibleVisibleFirmTypes.map((firmType) => (
              <div key={firmType} className={classes.radioDiv}>
                <CrmRadio
                  checked={this.state.firmType === firmType}
                  disabled={fixedType && this.state.firmType !== firmType}
                  onChange={() => this.handleBusinessTypeChange(firmType)}
                  value={firmType}
                  name="radio-group-firmType"
                />
                <span>{firmType}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  renderAsDropdown(possibleVisibleFirmTypes) {
    const { classes, fixedType } = this.props;
    return (
      <div className={classes.formFramework_content}>
        <div className={cx(classes.formFramework_item, classes.formFramework_businessTypeItem)}>
          <KSelect
            id="businessTypeDropdown"
            name="businessType"
            fullWidth={true}
            label="Business Type"
            disabled={!!fixedType}
            liveOptions={possibleVisibleFirmTypes}
            value={this.state.firmType}
            onChange={(event) => this.handleBusinessTypeChange(event.target.value)}
          />
        </div>
      </div>
    );
  }

  renderAsUnchangeable(firmType) {
    const { classes } = this.props;
    return (
      <div className={classes.formFramework_content}>
        <div className={cx(classes.formFramework_item, classes.formFramework_businessTypeItem)}>
          <div className={classes.fixedAttributeLabel}>Business Type</div>
          <div className={classes.fixedAttributeValue}>{firmType}</div>
        </div>
      </div>
    );
  }

  getAvailableFirmTypes() {
    const dropdownSpecs = this.props.dropdowns;
    const orgTypeSpec = dropdownSpecs.find((dds) => dds.name === 'Referrer Organization Type');
    const filteredSpecs = this.props.filterOutPrivatePractitioners
      ? this.props.visibleFirmId
        ? orgTypeSpec.items.filter((is) => is.text !== 'Private Practitioner')
        : orgTypeSpec.items.slice(0)
      : orgTypeSpec.items.slice(0);
    const itemSpecs = filteredSpecs.sort((a, b) => a.position - b.position);
    return itemSpecs.map((is) => is.text);
  }

  render() {
    const possibleVisibleFirmTypes = this.getAvailableFirmTypes();
    if (!possibleVisibleFirmTypes || (possibleVisibleFirmTypes && possibleVisibleFirmTypes.length <= 3)) {
      return this.renderAsRadioButtons(possibleVisibleFirmTypes);
    } else {
      return this.renderAsDropdown(possibleVisibleFirmTypes);
    }
  }
}

const mapStateToProps = (state) => ({
  dropdowns: state.firmInfo.dropdowns,
});

export default connect(mapStateToProps)(withStyles(businessTypeWidgetStyles)(BusinessTypeWidget));
